module.exports = __webpack_public_path__ + "img/C03TechHorsemanChampion_ua.077f16c1.webp";